// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import dayjs from 'dayjs';
import timezoneDayJs from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezoneDayJs);

export default function formatTimeToSkip(timeSeconds: number, timezone: string) {
  const date = dayjs.unix(timeSeconds).tz(timezone);
  return date.format('MM/DD/YYYY');
}
